/**
 * Split markdown into text / mermaid / code fence segments.
 *
 * Chat UI must render ```mermaid fences as diagrams. The line-collapsing
 * message formatter would otherwise turn triple-backtick fences into
 * visible ``mermaid inline junk.
 */
export function splitMarkdownSegments(text) {
  if (!text) return [{ type: "text", text: "" }];

  const segments = [];
  const fenceRe = /```([^\n`]*)\r?\n([\s\S]*?)```/g;
  let last = 0;
  let match;

  while ((match = fenceRe.exec(text)) !== null) {
    if (match.index > last) {
      segments.push({ type: "text", text: text.slice(last, match.index) });
    }
    const lang = String(match[1] || "")
      .trim()
      .toLowerCase();
    const source = String(match[2] || "").replace(/\s+$/, "");
    if (lang === "mermaid") {
      segments.push({ type: "mermaid", source });
    } else {
      segments.push({ type: "code", lang, source });
    }
    last = match.index + match[0].length;
  }

  if (last < text.length) {
    segments.push({ type: "text", text: text.slice(last) });
  }

  return segments.length ? segments : [{ type: "text", text: "" }];
}
